interface ForgotPasswordState {
  loading: boolean;
  user: any;
  submitted: boolean
}

const defaultState: ForgotPasswordState = {
  loading: false,
  submitted: false,
  user: {}
};

const reducer = (state = defaultState, action: any = {}) => {
  switch (action.type) {
 
    case "RESET_PASSWORD_PENDING": {
      return {
        ...state,
        loading: true,
        errors: null,
        submitted: false
      };
    }
    
    case "RESET_PASSWORD_FULFILLED": {        
      return {
        ...state,      
        loading: false,
        submitted: true
      };
    }

    case "RESET_PASSWORD_REJECTED": {
      return {
        ...state,
        user: action.meta.user,
        errors: action.payload.response.data.errors,
        loading: false,
        submitted: false
      };
    }

    default:
      return state;
  }
};

export default reducer;
